import React, { useState, useEffect } from 'react';
import PetCard from '../components/PetCard';
import './Favourites.css';

const Favourites = () => {
  const [favorites, setFavorites] = useState([]);

  const allPets = [
    {
      id: 1,
      name: 'Simba',
      breed: 'Rottweiler',
      age: '2 years',
      gender: 'Male',
      location: 'Mumbai, Maharashtra',
      image: 'https://images.unsplash.com/photo-1567752881298-894bb81f9379?w=400',
      type: 'Dog',
      postedBy: 'User',
      adoptOrRehome: 'Adopt'
    },
    {
      id: 2,
      name: 'Luna',
      breed: 'Persian Cat',
      age: '1 year',
      gender: 'Female',
      location: 'Delhi, India',
      image: 'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=400',
      type: 'Cat',
      postedBy: 'NGO',
      adoptOrRehome: 'Adopt'
    },
    {
      id: 4,
      name: 'Bella',
      breed: 'Labrador',
      age: '1.5 years',
      gender: 'Female',
      location: 'Pune, Maharashtra',
      image: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=400',
      type: 'Dog',
      postedBy: 'NGO',
      adoptOrRehome: 'Adopt'
    }
  ];

  useEffect(() => {
    const savedFavorites = localStorage.getItem('favorites');
    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }
  }, []);

  const favoritePets = allPets.filter(pet => favorites.includes(pet.id));

  const toggleFavorite = (petId) => {
    const newFavorites = favorites.includes(petId)
      ? favorites.filter(id => id !== petId)
      : [...favorites, petId];
    
    setFavorites(newFavorites);
    localStorage.setItem('favorites', JSON.stringify(newFavorites));
  };

  const handleAdoptNow = (pet) => {
    console.log(`Adopt Now clicked for: ${pet.breed} - ${pet.name}`);
  };

  return (
    <div className="favourites-page">
      <div className="page-header">
        <h1>❤️ My Favourites</h1>
        <p>Pets you've marked as favorites ({favoritePets.length})</p>
      </div>

      {favoritePets.length > 0 ? (
        <div className="favorites-grid">
          {favoritePets.map(pet => (
            <PetCard
              key={pet.id}
              pet={pet}
              isFavorite={true}
              toggleFavorite={toggleFavorite}
              handleAdoptNow={handleAdoptNow}
            />
          ))}
        </div>
      ) : (
        <div className="empty-favorites">
          <span className="empty-icon">💔</span>
          <h3>No favorites yet</h3>
          <p>Start adding pets to your favorites by clicking the heart icon</p>
          <a href="/adopt" className="browse-btn">Browse Pets</a>
        </div>
      )}
    </div>
  );
};

export default Favourites;
